'use client';

import {
  InverseHeader,
  useHeaderContext,
} from '@jouzen/ecom-components/layout';
import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import RichText from '@/app/components/RichText';

const renderSupportLink = (chunks: React.ReactNode) => (
  <BodyLink href="https://support.ouraring.com/hc/" target="_blank">
    {chunks}
  </BodyLink>
);

const renderPartnershipLink = (chunks: React.ReactNode) => (
  <BodyLink href="https://s.ouraring.com/oura-partners-contact" target="_blank">
    {chunks}
  </BodyLink>
);

const Content = () => {
  const t = useTranslations();
  const { setInverse } = useHeaderContext()!;

  useEffect(() => {
    setInverse(true);
    return () => setInverse(true);
  }, [setInverse]);

  return (
    <>
      <InverseHeader enter>
        <div className="py-24">
          <LayoutGrid>
            <Typography
              variant="h2"
              Element="h1"
              color="light"
              className="col-main"
            >
              {t('contact_title')}
            </Typography>
          </LayoutGrid>
        </div>
      </InverseHeader>
      <LayoutGrid className="gap-y-8 bg-white py-16">
        <div className="col-main lg:col-end-12">
          <Typography variant="h4" Element="h2">
            {t('contact_section_1_heading')}
          </Typography>
        </div>

        <div className="col-main lg:col-start-13 lg:col-end-main">
          <div className="mb-8">
            <Typography variant="h5" Element="h3">
              {t('contact_customer_support_title')}
            </Typography>
            <Typography>
              <RichText
                messageKey="contact_customer_support_body"
                tValues={{
                  a: renderSupportLink,
                }}
              />
            </Typography>
          </div>

          <Typography variant="h5" Element="h3">
            {t('contact_brand_partnership_title')}
          </Typography>

          <Typography>
            <RichText
              messageKey="contact_brand_partnership_body"
              tValues={{
                a: renderPartnershipLink,
              }}
            />
          </Typography>
        </div>

        <div className="col-main lg:col-end-12 lg:row-start-2 lg:pt-8">
          <Typography variant="h4" Element="h2">
            {t('contact_section_2_heading')}
          </Typography>
        </div>

        <div className="col-main lg:col-start-13 lg:col-end-main lg:row-start-2 lg:pt-8">
          <Typography variant="h5" className="lg:pt-2">
            {t('office_locations')}
          </Typography>
        </div>
      </LayoutGrid>
    </>
  );
};

export default Content;
